import { Listing } from "@app/data/listing";
import { ItemListing } from "../../shopping/cart";
import { User } from "@app/data/user";

export enum ElementType {
  Product = "application/product",
  Toc = "application/toc",
  Image = "image/*",
  Text = "text/html",
}
export class Element {
  type: string;
  properties: Listing;
}

export interface Cell {
  x: number;
  y: number;
  width: number;
  height: number;
  accepts?: ElementType[];
  read_only?: boolean;
  reverse?: boolean;
  alternate_left_right?: boolean;
  background_color?: string;
  lock?: boolean;
  properties?: Record<string, any>;
}

export interface PageLayout {
  _id: string;
  version: number;
  title: string;
  type: string;
  owner?: string;
  show_headers_footers?: boolean;
  cells: Cell[];
  availability?: string;
  margin?: number;
  headerHeight?: number;
  footerHeight?: number;
  ordering?: number;
  public?: boolean;
  created_at?: Date;
}

export interface Page {
  header?: {
    properties?: {
      html?: string | null;
      bgColor?: string | null;
    };
  };
  footer?: {
    properties?: {
      html?: string | null;
      bgColor?: string | null;
    };
  };
  kind?: string;
  layout?: string | PageLayout;
  columns?: any[];
  pageLayout?: PageLayout;
  page?: string;
  background_color?: string;
  html?: string;
  url?: string;
  elements?: any[];
  headerElements?: any[];
  footerElements?: any[];
  showHeadersFooters?: boolean;
}
export enum TemplatePageKind {
  FrontCover = "front_cover",
  BackCover = "back_cover",
  TableOfContents = "table_of_contents",
  WholesaleContract = "wholesale_contract",
  WholesaleForm = "wholesale_form",
}

export enum TemplateTag {
  Retail = "retail",
  Wholesale = "wholesale",
}

export class TemplatePage {
  _id?: string;
  layout: string;
  kind: TemplatePageKind;
}

export class Template {
  _id?: string;
  title: string;
  pages: TemplatePage[];
  tags: TemplateTag[];
  created_at?: Date;
  updated_at?: Date;
}

export interface Catalog {
  user?: User;
  id?: string;
  _id?: string;
  __v?: number;
  title: string;
  version: number;
  frontCover?: string;
  category?: string;
  download_number?: number;
  slug?: string;
  tags?: [string];
  created_at?: Date;
  updated_at?: Date;
  branding_css?: string;
  custom_css?: string;
  pages: Page[];
  font_links: string[];
  listings?: ItemListing[];
  categories?: string[];
  default_price_template?: any;
  default_images_style?: any;
  default_price_template_style?: any;
  default_footer?: string;
  settings: {
    layout: string;
    flow_layout_columns: number;
    products_link: string;
    public: boolean;
  };
}
export class CatalogRequest {
  public name: string;
  public email: string;
  public deadline: string;
}
